import React, { useMemo } from 'react';
import { useGetTradeInitiationSourcesQuery } from 'store/services/admin/analyticsApi';
import { AnalyticsPeriod } from 'types/interfaces/admin/analytics';
import StackedBarChart, { StackedBarChartRow } from 'components/admin/charts/StackedBarChart';

interface Props {
  period: AnalyticsPeriod;
  onPeriodChange: (period: AnalyticsPeriod) => void;
}

// Distinct palette from the card-add charts so the two Product-tab stacked charts read apart.
const SOURCE_COLORS: Record<string, string> = {
  'send-cards': '#3B82F6',
  profile: '#22C55E',
  'trade-alerts': '#E02CDC',
  unknown: '#6B7280',
};

const TradeInitiationSourcesChart: React.FC<Props> = ({ period, onPeriodChange }) => {
  const { data, isLoading, error, refetch } = useGetTradeInitiationSourcesQuery({ period });

  const rows = useMemo<StackedBarChartRow[] | undefined>(
    () => data?.map((r) => ({ date: r.date, dimension: r.source, value: r.cardCount })),
    [data]
  );

  return (
    <StackedBarChart
      title="Cards in Initiated Trades by Source"
      subtitle="Daily count of cards initiated, by surface (UTC)"
      period={period}
      onPeriodChange={onPeriodChange}
      data={rows}
      isLoading={isLoading}
      error={!!error}
      onRetry={refetch}
      colorPalette={SOURCE_COLORS}
      valueNoun="cards in initiated trades"
      emptyMessage="No trades initiated in this period"
    />
  );
};

export default TradeInitiationSourcesChart;
